import Stylus from './Stylus';
import ObjectSelectionBrush from './ObjectSelectionBrush';
import type UrlInputModalController from '../components/url-input/UrlInputModalController';
import type WhiteboardController from '../controllers/WhiteboardController';
import type Canvas from '../objects/Canvas';

/**
 * A stylus that allows the user select an object for the UrlInputModal.
 */
class StylusLinkObjectSelection extends Stylus {
  private brush: ObjectSelectionBrush;
  private readonly urlInputModalController: UrlInputModalController;
  private readonly canvas: Canvas;

  constructor({
    controller,
    canvas,
    urlInputModalController,
  }: {
    controller: WhiteboardController;
    canvas: Canvas;
    urlInputModalController: UrlInputModalController;
  }) {
    super({ controller });
    this.urlInputModalController = urlInputModalController;
    this.canvas = canvas;
  }

  activate() {
    this.brush = new ObjectSelectionBrush(
      this.canvas,
      this.urlInputModalController
    );
    this.canvas.isDrawingMode = true;
    this.canvas.freeDrawingBrush = this.brush;
  }

  deactivate() {
    this.brush?.cleanupLastRender();
  }

  description() {
    return 'Link object to URL';
  }

  cursor() {
    return 'pointer';
  }
}

export default StylusLinkObjectSelection;
